import React, { useState } from "react";

import { t } from "i18next";
import { Trans } from "react-i18next";

import LookupsAPI from "../../API/lookups.api";
import TrendChart from "../../components/Charts/TrendChart";
import { getMappedFilters } from "../../utils/FilterHelpers";
import DashboardAPI from "../../API/dashboard.api";

const Analytics = () => {
    const [materialTrendData, setMaterialTrendData] = useState({});
    const [lotTrendData, setLotTrendData] = useState({});
    const [supplierTrendData, setSupplierTrendData] = useState({});

    const [isMaterialTrendLoading, setIsMaterialTrendLoading] = useState(false);
    const [isLotTrendLoading, setIsLotTrendLoading] = useState(false);
    const [isSupplierTrendLoading, setIsSupplierTrendLoading] = useState(false);

    const [materials, setMaterials] = useState([]);
    const [lots, setLots] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    const getMaterialsLookup = async (filters = null) => {
        const _filters = getMappedFilters(filters);
        const result = await LookupsAPI.getTrendMaterials(_filters);
        setMaterials(result);
    };

    const getLotsLookup = async (filters = null) => {
        const _filters = getMappedFilters(filters);
        const result = await LookupsAPI.getTrendLots(_filters);
        setLots(result);
    };

    const getSuppliersLookup = async (filters = null) => {
        const _filters = getMappedFilters(filters);
        const result = await LookupsAPI.getTrendSuppliers(_filters);

        setSuppliers(mapSuppliersLookup(result));
    };

    const getScansMaterialTrend = async (material, filters = null) => {
        setIsMaterialTrendLoading(true);
        const _filters = getMappedFilters(filters, [], ["lastReadings"]);

        const result = await DashboardAPI.getScansTrend({
            ..._filters,
            materialId: material.value,
        });
        setMaterialTrendData(result || {});
        setIsMaterialTrendLoading(false);
    };

    const getScansLotTrend = async (lot, filters = null) => {
        setIsLotTrendLoading(true);
        const _filters = getMappedFilters(filters, [], ["lastReadings"]);

        const result = await DashboardAPI.getScansTrend({
            ..._filters,
            lotId: lot.value,
        });
        setLotTrendData(result || {});
        setIsLotTrendLoading(false);
    };

    const getScansSupplierTrend = async (supplierMaterial, filters = null) => {
        setIsSupplierTrendLoading(true);
        const _filters = getMappedFilters(filters, [], ["lastReadings"]);

        const result = await DashboardAPI.getScansTrend({
            ..._filters,
            supplierId: supplierMaterial.supplierId,
            materialId: supplierMaterial.materialId,
        });

        setSupplierTrendData(result || {});
        setIsSupplierTrendLoading(false);
    };

    const mapSuppliersLookup = (suppliers) => {
        return suppliers.map((supplier) => ({
            ...supplier,
            options: supplier.options.map((row) => ({
                ...row,
                materialId: row.value,
                supplierName: supplier.label,
                supplierId: supplier.value,
                value: `${supplier.label} - ${row.value}`,
            })),
        }));
    };

    return (
        <div id="customer-content" className="customer-content">
            <header className="main-content-header flex items-center justify-between">
                <div className="flex justify-start">
                    <h1 className="h1 pr-1">
                        <Trans i18nKey="analytics">Analytics</Trans>
                    </h1>
                </div>
            </header>
            <TrendChart
                title={t("scansTrendMaterial")}
                component="trend-material"
                entity="material"
                dropdownOptions={materials}
                trendData={materialTrendData}
                isLoading={isMaterialTrendLoading}
                dropdownPlaceholder={t("selectPlaceholder", {
                    entity: "Material",
                })}
                refetchData={getScansMaterialTrend}
                refetchLookup={getMaterialsLookup}
            />
            <TrendChart
                title={t("scansTrendLot")}
                component="trend-lot"
                entity="lot"
                dropdownOptions={lots}
                trendData={lotTrendData}
                isLoading={isLotTrendLoading}
                dropdownPlaceholder={t("selectPlaceholder", {
                    entity: "Lot",
                })}
                refetchData={getScansLotTrend}
                refetchLookup={getLotsLookup}
            />
            <TrendChart
                title={t("scansTrendSupplier")}
                component="supplier-lot"
                entity="supplier"
                dropdownOptions={suppliers}
                trendData={supplierTrendData}
                isLoading={isSupplierTrendLoading}
                dropdownPlaceholder={t("selectPlaceholder", {
                    entity: t("supplier"),
                })}
                refetchData={getScansSupplierTrend}
                refetchLookup={getSuppliersLookup}
            />
        </div>
    );
};

export default Analytics;
